import { render, staticRenderFns } from "./KdsTopbar.vue?vue&type=template&id=1f171d30&scoped=true"
import script from "./KdsTopbar.vue?vue&type=script&lang=js"
export * from "./KdsTopbar.vue?vue&type=script&lang=js"
import style0 from "./KdsTopbar.vue?vue&type=style&index=0&id=1f171d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f171d30",
  null
  
)

export default component.exports